import { axiosService } from "./axiosService";

const holidayApi = {
    getAll() {
        const url = '/holiday';
        return axiosService.get(url)
    },
    createHoliday(body) {
        const url = '/holiday';
        return axiosService.post(url, body)
    },
    deleteHoliday(id) {
        const url = `/holiday/${id}`;
        return axiosService.delete(url)
    },
}

export default holidayApi;